import React from 'react';
import { useTranslation } from "react-i18next";

const ContactMap = () => {
  const { t } = useTranslation(); 

  return (
    <div className="contact-section">
      <h3 className="contact-title">🗺️ {t("contact.map.title")}</h3>
      <iframe
        title="Goats Karate Poznan Location Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9743.662394279609!2d16.934672008547793!3d52.37195040000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47045bc3d680856f%3A0xe1b076ece665e5a2!2sGOATS%20Karate%20Team%20Pozna%C5%84!5e0!3m2!1sen!2spl!4v1752235502360!5m2!1sen!2spl"
        className="contact-map"
        allowFullScreen 
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade">
      </iframe>
    </div>
  );
};

export default ContactMap;
